// Lux Coffee: journalen och artikelsidan (Shopify). Portad från lux-website/js/journal.js.
// Journal: punkterna 01 02 03 i bildspelet, filterflikar och "Upptäck" i kategoribandet (?kategori=<tagg>).
// Artikel: bilder ur artikeltexten flyttas till bildkolumnen, och texten står kvar (sticky) när den ryms.
// Kopplas per sektion och kopplas om när temaredigeraren laddar om en sektion.
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = "1"; return true; };

  /* ---------- Journal ---------- */
  var initJournal = function (root) {
    $$("[data-journal]", root).forEach(function (main) {
      if (!once(main, "luxInit")) return;

      // 1. Bildspel
      var slides = $$(".jr-feat__slide", main);
      $$("[data-feat-dot]", main).forEach(function (dot, i, all) {
        dot.addEventListener("click", function () {
          all.forEach(function (d, k) { d.setAttribute("aria-pressed", String(k === i)); });
          slides.forEach(function (s, k) { s.hidden = k !== i; });
        });
      });

      // 3. Filter
      var filterEl = $("[data-filter]", main);
      var grid = $("[data-grid]", main);
      if (!filterEl || !grid) return;
      var ids = $$("[data-filter-id]", filterEl).map(function (b) { return b.dataset.filterId; });
      var setFilter = function (id) {
        if (ids.indexOf(id) < 0) id = "";
        $$("[data-filter-id]", filterEl).forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.filterId === id)); });
        $$(".jcard", grid).forEach(function (c) {
          var cats = " " + (c.getAttribute("data-cat") || "") + " ";
          c.hidden = !!id && cats.indexOf(" " + id + " ") < 0;
        });
      };
      var pushFilter = function (id) {
        var u = new URL(location.href);
        if (id) u.searchParams.set("kategori", id); else u.searchParams.delete("kategori");
        history.replaceState(history.state, "", u.pathname + u.search + u.hash);
      };
      filterEl.addEventListener("click", function (e) {
        var b = e.target.closest("[data-filter-id]");
        if (!b) return;
        setFilter(b.dataset.filterId);
        pushFilter(b.dataset.filterId);
      });
      // 2. "Upptäck" i kategoribandet filtrerar rutnätet och rullar dit
      $$("[data-cat-link]", main).forEach(function (l) {
        l.addEventListener("click", function (e) {
          var id = l.dataset.catLink;
          if (ids.indexOf(id) < 0) return;
          e.preventDefault();
          setFilter(id);
          pushFilter(id);
          var list = $("[data-list]", main);
          if (list) list.scrollIntoView({ block: "start" });
          var btn = $('[data-filter-id="' + id + '"]', filterEl);
          if (btn) btn.focus({ preventScroll: true });
        });
      });
      setFilter(new URLSearchParams(location.search).get("kategori") || "");
    });
  };

  /* ---------- Artikel ---------- */
  var initArticle = function (root) {
    $$("[data-article]", root).forEach(function (box) {
      if (!once(box, "luxInit")) return;
      var media = $("[data-ar-media]", box);
      var copy = $("[data-ar-copy]", box);

      // Bilder i artikeltexten visas, som i designen, i bildkolumnen (desktop) och i bildraden överst (mobil).
      if (media && copy) {
        $$("img", copy).forEach(function (img) {
          var fig = img.closest("figure");
          var capText = "";
          if (fig && copy.contains(fig)) {
            var fc = $("figcaption", fig);
            capText = fc ? fc.textContent.trim() : "";
          }
          var holder = fig && copy.contains(fig) ? fig : img;
          // Ta bort ett omslag (p, div, a) som bara innehåller bilden
          var parent = holder.parentElement;
          var out = document.createElement("figure");
          out.className = "ar__figure";
          var frame = document.createElement("div");
          frame.className = "ar__img media-cover";
          img.removeAttribute("style");
          img.removeAttribute("width");
          img.removeAttribute("height");
          img.loading = "lazy";
          frame.appendChild(img);
          out.appendChild(frame);
          if (capText) {
            var cap = document.createElement("figcaption");
            cap.className = "ar__caption";
            cap.textContent = capText;
            out.appendChild(cap);
          }
          media.appendChild(out);
          if (holder !== img && holder.parentElement) holder.parentElement.removeChild(holder);
          while (parent && parent !== copy && copy.contains(parent) && parent.textContent.trim() === "" && !$("img, iframe, video", parent)) {
            var up = parent.parentElement;
            parent.parentElement.removeChild(parent);
            parent = up;
          }
        });
        media.hidden = !media.children.length;
      }

      // Texten står kvar medan bilderna rullar förbi, men bara när den ryms i fönstret.
      var sticky = $("[data-sticky]", box);
      var stack = sticky && $(".ar__stack", sticky);
      if (!sticky || !stack) return;
      var fit = function () {
        if (!document.contains(sticky)) return;
        var head = document.querySelector(".site-header");
        var room = window.innerHeight - (head ? head.offsetHeight : 0) - 40;
        sticky.classList.toggle("is-static", stack.offsetHeight + 80 > room);
      };
      fit();
      window.addEventListener("resize", fit);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    });
  };

  var init = function (root) { initJournal(root); initArticle(root); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
